<template>
    <v-container>
        <gridView v-if="showGrid"/>
    </v-container>
</template>

<script>
import gridView from './grid'

export default {
  name: 'parameter',

  data: () => ({
    showGrid: true,
    item: {}
  }),

  components: {
    gridView
  },

  methods: {
    toGrid () {
      this.showGrid = true
    }
  }
}
</script>
